import React, { useState, useEffect, useRef } from "react";
import HTMLFlipBook from "react-pageflip";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";

const generateComicImages = (comicNumber) => {
  const baseURL = `https://hydroplay.mx/comics/comic${comicNumber}/`;
  return [
    `${baseURL}portada${comicNumber}.png`,
    `${baseURL}pag1.png`,
    `${baseURL}pag2.png`,
    `${baseURL}contraportada.png`,
  ];
};

const comics = Array.from({ length: 10 }, (_, i) => ({
  id: i + 1,
  title: `Cómic ${i + 1}`,
  cover: `https://hydroplay.mx/comics/comic${i + 1}/portada${i + 1}.png`, // Portada
  images: generateComicImages(i + 1),
}));

const AllComics = () => {
  const [selectedComic, setSelectedComic] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [dimensions, setDimensions] = useState({ width: 400, height: 500 });
  const flipBookRef = useRef(null);

  useEffect(() => {
    const updateSize = () => {
      const screenWidth = window.innerWidth;
      const newWidth = screenWidth < 600 ? screenWidth * 0.9 : 400;
      const newHeight = newWidth * 1.25;
      setDimensions({ width: newWidth, height: newHeight });
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const handleComicClick = async (comic) => {
    setIsLoading(true);

    // Pre-cargar imágenes antes de mostrar el cómic
    await Promise.all(
      comic.images.map(
        (src) =>
          new Promise((resolve) => {
            const img = new Image();
            img.src = src;
            img.onload = resolve;
          })
      )
    );

    setSelectedComic(comic);
    setIsLoading(false);
  };

  return (
    <div className="allcomics-container">
      <h1 style={{ color: "#9359b4" }}>Biblioteca de Cómics</h1>

      {/* Swiper para la vitrina de cómics */}
      <Swiper
        modules={[Navigation, Pagination]}
        slidesPerView={6}
        spaceBetween={0} /* Eliminamos el espacio entre slides */
        navigation
        pagination={{ clickable: true }}
        loop={true} /* Permite que el último cómic no quede fuera */
        breakpoints={{
          320: { slidesPerView: 2 },
          600: { slidesPerView: 4 },
          1024: { slidesPerView: 6 },
        }}
        className="comic-swiper"
      >
        {comics.map((comic) => (
          <SwiperSlide key={comic.id}>
            <div
              className="comic-thumbnail"
              onClick={() => handleComicClick(comic)}
            >
              <img
                src={comic.cover}
                alt={comic.title}
                className="comic-image"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Mostrar el cómic seleccionado */}
      {selectedComic && (
        <div className={`flipbook-container ${isLoading ? "loading" : ""}`}>
          {isLoading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Cargando cómic...</p>
            </div>
          ) : (
            <HTMLFlipBook
              width={dimensions.width}
              height={dimensions.height}
              showCover={true}
              mobileScrollSupport={true}
              ref={flipBookRef}
            >
              {selectedComic.images.map((image, index) => (
                <div className="page" key={index}>
                  <img
                    src={image}
                    alt={`Page ${index + 1}`}
                    className="page-image"
                  />
                </div>
              ))}
            </HTMLFlipBook>
          )}
        </div>
      )}
    </div>
  );
};

export default AllComics;
